var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hamburger",class:{
    'hamburger--active': _vm.active,
  },attrs:{"type":"button","aria-label":_vm.$t('menu')},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"hamburger__line",class:{
      'hamburger__line--active': _vm.active,
    }})])}
var staticRenderFns = []

export { render, staticRenderFns }